export default class TestimonialsMultiple {
    constructor(element) {
        this.selector = element;
        this.initSlider();
    }

    async initSlider() {
        const target = this.selector.querySelector('[data-slider]');

        if (!target) {
            return;
        }

        const { default: Glide } = await import('@glidejs/glide');
        this.Glide = Glide;

        const slider = this.mountSlider();

        this.updateSliderBullets();
        this.updateSliderNavigation();

        this.slidePrev(slider);
        this.slideNext(slider);

        slider.on('run.after', () => {
            this.updateSliderActiveBullet(slider.index);
        });

        this.resizeSlider(slider);
    }

    mountSlider() {
        return new this.Glide(this.selector, {
            type: 'slider',
            perView: 1,
            animationDuration: 300,
            rewindDuration: 300,
            animationTimingFunc: 'ease-in-out',
            gap: 0,
            rewind: true,
        }).mount();
    }

    slidePrev(slider) {
        const button = this.selector.querySelector('[data-slider-button="prev"]');

        if (!button) {
            return;
        }

        button.addEventListener('click', () => {
            slider.go('<');
        });
    }

    slideNext(slider) {
        const button = this.selector.querySelector('[data-slider-button="next"]');

        if (!button) {
            return;
        }

        button.addEventListener('click', () => {
            slider.go('>');
        });
    }

    resizeSlider(slider) {
        let timeout;
        let prevWidth = window.innerWidth;

        window.addEventListener('resize', () => {
            const currentWidth = window.innerWidth;

            if (currentWidth === prevWidth) {
                return;
            }

            clearTimeout(timeout);
            timeout = setTimeout(() => {
                slider.update({ perView: 1, startAt: 0 });
                this.updateSliderBullets();
                this.updateSliderNavigation();
                this.updateSliderActiveBullet(slider.index);
                prevWidth = currentWidth;
            }, 300);
        });
    }

    updateSliderBullets() {
        const items = this.selector.querySelectorAll('[data-slider-item]');
        const count = items.length;
        const bullets = this.selector.querySelectorAll('[data-slider-bullet]');

        bullets.forEach((bullet, index) => {
            if (index < count) {
                bullet.classList.remove('hidden');
            } else {
                bullet.classList.add('hidden');
            }
        });
    }

    updateSliderNavigation() {
        const navigation = this.selector.querySelector('[data-slider-navigation]');
        const items = this.selector.querySelectorAll('[data-slider-item]');

        if (!navigation) {
            return;
        }

        if (items.length > 1) {
            navigation.classList.remove('hidden');
        } else {
            navigation.classList.add('hidden');
        }
    }

    updateSliderActiveBullet(index) {
        const bullets = this.selector.querySelectorAll('[data-slider-bullet]:not(.hidden)');
        const activeBullet = this.selector.querySelector('[data-slider-bullet].active-slider-bullet');

        if (bullets.length === 0) {
            return;
        }

        if (activeBullet) {
            activeBullet.classList.remove('active-slider-bullet');
        }

        if (bullets[index]) {
            bullets[index].classList.add('active-slider-bullet');
        }
    }
}
